import type { HistoryItem } from "../../types";
import { groupHistoryByPeriod } from "../../utils/period-grouping";
import { HistoryRow } from "./history-list";

type GroupedHistoryListProps = {
  items: HistoryItem[];
};

export function GroupedHistoryList({ items }: GroupedHistoryListProps) {
  if (items.length === 0) {
    return (
      <div class="text-center py-8 text-text-muted">
        No check-ins yet. Your submitted check-ins will appear here.
      </div>
    );
  }

  const groups = groupHistoryByPeriod(items);

  return (
    <div class="flex flex-col gap-6">
      {groups.map((group) => (
        <div key={group.key}>
          <h3 class="text-sm font-semibold text-text-muted uppercase tracking-wide mb-3">
            {group.label}
          </h3>
          <div class="flex flex-col gap-2">
            {group.items.map((item) => (
              <HistoryRow key={item.id} item={item} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
